import api from './api';

const DEFAULT_ITEMS_PER_PAGE = 10;
export const ITEMS_PER_PAGE_OPTIONS = [10, 20, 50, 100];

const withStoreId = (storeId, config = {}) => (storeId
  ? { ...config, _storeId: storeId }
  : config);

const normalizePaginated = (response) => ({
  data: response.data?.data || [],
  pageIndex: response.data?.pageIndex ?? 0,
  itemsPerPage: response.data?.itemsPerPage ?? DEFAULT_ITEMS_PER_PAGE,
  totalItems: response.data?.totalItems ?? 0,
});

const StoreCustomerService = {
  getStoreCustomers: async (storeId, { pageIndex = 0, itemsPerPage = DEFAULT_ITEMS_PER_PAGE, search = '' } = {}) => {
    const response = await api.get('/customers', withStoreId(storeId, {
      params: {
        pageIndex,
        itemsPerPage,
        ...(search ? { search } : {}),
      },
    }));
    return normalizePaginated(response);
  },

  getStoreCustomerDropdown: async (storeId) => {
    const response = await api.get('/customers/dropdown', withStoreId(storeId));
    return Array.isArray(response.data) ? response.data : [];
  },

  checkCustomerEmail: async (email, storeId) => {
    const response = await api.get('/customers/email-check', {
      params: { email },
      ...withStoreId(storeId),
    });
    return response.data;
  },

  checkCustomerPhone: async ({ countryCode, number }, storeId) => {
    const response = await api.get('/customers/phone-check', {
      params: { countryCode, number },
      ...withStoreId(storeId),
    });
    return response.data;
  },

  createStoreCustomer: async (customerData, storeId) => {
    const response = await api.post('/customers', customerData, withStoreId(storeId));
    return response.data;
  },

  importStoreCustomers: async (payload, storeId) => {
    const response = await api.post('/customers/import', payload, withStoreId(storeId));
    return response.data;
  },

  getStoreCustomer: async (storeId, customerId) => {
    const response = await api.get(`/customers/${customerId}`, withStoreId(storeId));
    return response.data;
  },

  getUpcomingAppointments: async (storeId, customerId) => {
    const response = await api.get(`/customers/${customerId}/upcoming-appointments`, withStoreId(storeId));
    return Array.isArray(response.data) ? response.data : [];
  },

  updateStoreCustomerProfile: async (storeId, customerId, profile) => {
    const response = await api.put(`/customers/${customerId}`, profile, withStoreId(storeId));
    return response.data;
  },
};

export default StoreCustomerService;
export { DEFAULT_ITEMS_PER_PAGE };
